import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {MenuNotification, OperationType} from '@models/sidebar/menu-notification';
import {MenuItem} from '@models/sidebar/menu-item';

export interface MachinePageSelection {
  machine: MenuItem;
  page: MenuItem;
}

@Injectable({
  providedIn: 'root'
})
export class MenuNotificationService {

  private behaviourSubject = new BehaviorSubject(new MenuNotification(OperationType.NONE, '', '', ''));
  currentMenuNotification = this.behaviourSubject.asObservable();

  private clickOnDashboardBehaviourSubject = new BehaviorSubject(new MenuItem());
  clickOnDashboardNotification = this.clickOnDashboardBehaviourSubject.asObservable();

  private clickOnBreadcrumbBehaviourSubject = new BehaviorSubject(new MenuItem());
  clickOnBreadcrumbNotification = this.clickOnBreadcrumbBehaviourSubject.asObservable();

  private redirectToInteractiveDataAnalysisBehaviorSubject = new BehaviorSubject(new MenuItem());
  redirectToInteractiveDataAnalysis = this.redirectToInteractiveDataAnalysisBehaviorSubject.asObservable();

  private machinePageSelectionBehaviorSubject = new BehaviorSubject<MachinePageSelection | null>(null);
  machinePageSelection = this.machinePageSelectionBehaviorSubject.asObservable();

  private redirectToGroupStatusPageBehaviorSubject = new BehaviorSubject(new MenuItem());
  redirectToGroupStatusPage = this.redirectToGroupStatusPageBehaviorSubject.asObservable();

  broadcast(message: MenuNotification) {
    this.behaviourSubject.next(message);
  }

  broadcastClickOnDashboard(menuItem: MenuItem) {
    this.clickOnDashboardBehaviourSubject.next(menuItem);
  }

  broadcastClickOnBreadcrumb(menuItem: MenuItem) {
    this.clickOnBreadcrumbBehaviourSubject.next(menuItem);
  }

  broadcastRedirectToInteractiveDataAnalysis(menuItem: MenuItem) {
    this.redirectToInteractiveDataAnalysisBehaviorSubject.next(menuItem);
  }

  broadcastMachinePageSelection(machine: MenuItem, page: MenuItem): void {
    this.machinePageSelectionBehaviorSubject.next({machine, page});
  }

  broadcastRedirectToGroupStatusPage(menuItem: MenuItem) {
    this.redirectToGroupStatusPageBehaviorSubject.next(menuItem);
  }
}
